import React from 'react';
import { InputDate, ModalContainer, InputHour } from '@welbe/web-design-system';
import { Button } from '@welbe/design-system';
import Analytics from 'helpers/analytics';

import { Subtitle } from '../Subtitle/Subtitle';

import {
	Wrapper,
	ContainerSubtitles,
	ContainerButton,
	TextHour,
	ContainerHour,
} from './ModalChangeDate.styles';
import { useChangeNewDate } from './ModalChangeDate.hooks';
import {
	FormattedDatesResult,
	getFormattedDatesSchedules,
} from 'utils/formatterDatesScheduled';

interface ModalChangeDateProps {
	visible: boolean;
	onToggleModal: () => void;
	subtitleOptions: any;
	typeProps?: any;
	bookDates?: any[];
	campaignId?: string;
	communicationId?: string;
	onRetryDates?: () => void;
}

export const ModalChangeDate = ({
	visible,
	onToggleModal,
	subtitleOptions,
	typeProps,
	bookDates,
	campaignId,
	communicationId,
	onRetryDates,
}: ModalChangeDateProps): JSX.Element => {
	const {
		form,
		handleChangeCalendar,
		handleChangeHour,
		handleSave,
		isLoading,
	} = useChangeNewDate({
		typeProps,
		campaignId,
		communicationId,
		onRetryDates,
		onToggleModal,
	});

	const handleToggleModal = () => {
		Analytics.track('campaign', 'close-change-end-date-campaign');
		onToggleModal();
	};

	const getFormattedValue = () => {
		if (form.date) {
			return form.date;
		}

		if (typeProps.initialValue) {
			return typeProps.initialValue;
		}

		return '';
	};

	const formattedDatesScheduled: FormattedDatesResult = bookDates
		? getFormattedDatesSchedules(bookDates)
		: undefined;

	return (
		<ModalContainer
			visible={visible}
			onClose={handleToggleModal}
			height="fit-content"
			width="360px"
		>
			<Wrapper>
				<InputDate
					onChange={handleChangeCalendar}
					label={typeProps?.label}
					scheduledDates={formattedDatesScheduled}
					value={getFormattedValue()}
					isOpen
				/>
				<ContainerSubtitles>
					{subtitleOptions.map((subtitleOption: any) => (
						<Subtitle
							key={subtitleOption.title}
							circleColor={subtitleOption.color}
							title={subtitleOption.title}
						/>
					))}
					<ContainerHour>
						<TextHour>Horário de envío</TextHour>
						<InputHour value={form.hour} onChange={handleChangeHour} />
					</ContainerHour>
					<ContainerButton>
						<Button type="button" variant="outline" onClick={handleToggleModal}>
							Cancelar
						</Button>
						<Button loading={isLoading} onClick={handleSave}>
							Guardar
						</Button>
					</ContainerButton>
				</ContainerSubtitles>
			</Wrapper>
		</ModalContainer>
	);
};
